(function () {
  const cfg = window.ARCUBE_IFRAME_CONFIG || {};
  const API = cfg.apiBase || '';

  const $ = id => document.getElementById(id);

  function showStep(name) {
    document.querySelectorAll('.aiw-step').forEach(el => el.classList.remove('aiw-step--active'));
    $(`aiw-step-${name}`).classList.add('aiw-step--active');
  }

  const PAX_LABELS = { ADT: 'Adulto', CHD: 'Niño', INF: 'Bebé' };

  function renderPassengerFields() {
    const adults = parseInt($('aiw-adults').value) || 1;
    const children = parseInt($('aiw-children').value) || 0;
    const infants = parseInt($('aiw-infants').value) || 0;
    const container = $('aiw-passengers-container');
    const pax = [];
    for (let i = 0; i < adults; i++) pax.push({ id: `ADT${i+1}`, type: 'ADT', num: i+1 });
    for (let i = 0; i < children; i++) pax.push({ id: `CHD${i+1}`, type: 'CHD', num: i+1 });
    for (let i = 0; i < infants; i++) pax.push({ id: `INF${i+1}`, type: 'INF', num: i+1 });
    container.innerHTML = pax.map(p => `
      <div class="aiw-passenger-block">
        <p class="aiw-passenger-label">${PAX_LABELS[p.type]} ${p.num}</p>
        <div class="aiw-form-row">
          <div class="aiw-form-group" style="flex:0 0 80px">
            <label>Título</label>
            <select id="aiw-ti-${p.id}">
              <option value="Mr">Mr</option>
              <option value="Mrs">Mrs</option>
              <option value="Ms">Ms</option>
              <option value="Miss">Miss</option>
            </select>
          </div>
          <div class="aiw-form-group">
            <label>Nombre</label>
            <input type="text" id="aiw-fn-${p.id}" placeholder="Juan" />
          </div>
          <div class="aiw-form-group">
            <label>Apellido</label>
            <input type="text" id="aiw-ln-${p.id}" placeholder="García" />
          </div>
        </div>
        <div class="aiw-form-row">
          <div class="aiw-form-group">
            <label>Email</label>
            <input type="email" id="aiw-em-${p.id}" placeholder="juan@ejemplo.com" />
          </div>
          <div class="aiw-form-group">
            <label>Fecha de nacimiento</label>
            <input type="date" id="aiw-dob-${p.id}" />
          </div>
        </div>
        <div class="aiw-form-group">
          <label>Teléfono (con prefijo, ej. +34612345678)</label>
          <input type="tel" id="aiw-ph-${p.id}" placeholder="+34612345678" />
        </div>
      </div>
    `).join('');
  }

  function buildPassengers(adults, children, infants) {
    const pax = [];
    for (let i = 0; i < adults; i++) pax.push({ id: `ADT${i+1}`, type: 'ADT' });
    for (let i = 0; i < children; i++) pax.push({ id: `CHD${i+1}`, type: 'CHD' });
    for (let i = 0; i < infants; i++) pax.push({ id: `INF${i+1}`, type: 'INF' });
    return pax;
  }

  function readPassengerData(passengers) {
    return passengers.map((p, i) => ({
      id: p.id,
      type: p.type,
      title: ($(`aiw-ti-${p.id}`) || {}).value || 'Mr',
      firstName: ($(`aiw-fn-${p.id}`) || {}).value || '',
      lastName: ($(`aiw-ln-${p.id}`) || {}).value || '',
      email: ($(`aiw-em-${p.id}`) || {}).value || '',
      dateOfBirth: ($(`aiw-dob-${p.id}`) || {}).value || '',
      phoneNumber: ($(`aiw-ph-${p.id}`) || {}).value || '',
      isPrimary: i === 0,
    }));
  }

  let currentPnr = '';
  let currentCorrelationId = '';
  let currentPassengers = [];

  const VARIANT_MAP = {
    FAST_TRACK: '57507048063324',
  };

  async function addAncillaryToShopifyCart(ancillary, pnr, transactionId) {
    const category = (ancillary.category || ancillary.vendor || '').toUpperCase();
    const variantId = VARIANT_MAP[category] || cfg.ancillaryVariantId || cfg.genericVariantId;
    if (!variantId) {
      console.warn('No variantId for category:', category);
      return;
    }
    const price = ancillary.price || ancillary.minimum_price || 0;
    const payload = {
      items: [{
        id: parseInt(variantId),
        quantity: 1,
        properties: {
          PNR: pnr,
          _arcube_data: JSON.stringify({
            id: ancillary.ancillaryId || ancillary.id || '',
            ancillaryId: ancillary.ancillaryId || ancillary.id || '',
            vendor: ancillary.vendor || ancillary.category || '',
            price: price,
            currency: ancillary.currency || 'USD',
            quantity: 1,
            description: ancillary.name || ancillary.description || '',
            vendorReferenceId: ancillary.vendorReferenceId || ancillary.vendor_reference_id || '',
            serviceDetails: ancillary.serviceDetails || ancillary.service_details || {},
            metadata: ancillary.metadata || {},
          }),
          _arcube_id: ancillary.ancillaryId || ancillary.id || '',
          _arcube_category: ancillary.vendor || ancillary.category || '',
          _arcube_correlation_id: ancillary.correlationId || currentCorrelationId || '',
          _arcube_transaction_id: transactionId || '',
          _precio_arcube: price,
          'Servicio': ancillary.name || ancillary.description || '',
          'Vuelo': pnr,
        },
      }],
    };
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!resp.ok) {
      const err = await resp.text();
      throw new Error(`Shopify cart error: ${err}`);
    }
    await resp.json();
    // Fetch cart drawer section HTML and inject it, then open drawer
    const cartDrawer = document.querySelector('cart-drawer');
    fetch(`/?section_id=cart-drawer`)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          cartDrawer.classList.remove('is-empty');
        }
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(sel => {
          const target = document.querySelector(sel);
          const source = doc.querySelector(sel);
          if (target && source) target.replaceWith(source);
        });
        // drawer stays closed — user opens it manually
      });
    // Refresh cart drawer
    fetch('/?section_id=cart-drawer')
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection = doc.querySelector('#shopify-section-cart-drawer');
        const currentSection = document.querySelector('#shopify-section-cart-drawer');
        if (currentSection && newSection) currentSection.innerHTML = newSection.innerHTML;
      });
    // Update cart icon count badge
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count;
        const bubble = document.querySelector('#cart-icon-bubble');
        if (!bubble) return;
        // Find or create the count badge span
        let badge = bubble.querySelector('.cart-count-bubble');
        if (!badge) {
          badge = document.createElement('div');
          badge.className = 'cart-count-bubble';
          badge.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span>`;
          bubble.appendChild(badge);
        } else {
          const ariaHidden = badge.querySelector('[aria-hidden]');
          if (ariaHidden) ariaHidden.textContent = count;
        }
      });
    return true;
  }

  async function loadWidget(pnr, passengers, passengerData) {
    currentPnr = pnr;
    showStep('loading');

    try {
      const segments = [
        {
          segmentId: 'SEG1',
          flightNumber: 'DM5801',
          departure: 'ATH',
          arrival: 'AMS',
          departureTime: '2026-12-23T11:52:00-05:00',
          arrivalTime: '2026-12-23T15:25:00-05:00',
          operatingCarrier: 'XY',
          passengerIds: passengers.map(p => p.id),
        },
      ];

      const tokenResp = await fetch(`${API}/api/token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pnr, passengers: passengerData, segments }),
      });
      if (!tokenResp.ok) throw new Error(`Token error ${tokenResp.status}`);
      const tokenData = await tokenResp.json();
      const token = tokenData.accessToken || tokenData.token || tokenData.access_token;
      if (!token) throw new Error('No se pudo obtener el token de sesión');

      await loadScript(`${cfg.widgetUrl}/arcube-widget.js`);

      // Log ALL raw messages from widget iframe so we can see exactly what it sends
      const widgetOrigin = new URL(cfg.widgetUrl).origin;
      window.addEventListener('message', (e) => {
        if (e.origin === widgetOrigin) {
          console.log('📨 RAW widget message:', JSON.stringify(e.data));
        }
      });

      window.addEventListener('arcube:widget:ready', () => {
        console.log('✅ arcube:widget:ready — sending passenger details');
        const iframe = document.querySelector('#arcube-widget iframe');
        if (!iframe) return;
        const primaryPax = passengerData[0] || {};
        iframe.contentWindow.postMessage({
          source: 'arcube-parent',
          version: '1.0',
          type: 'PASSENGER_DETAILS_UPDATED',
          payload: {
            customer: {
              id: passengers[0] ? passengers[0].id : 'PAX1',
              title: primaryPax.title || 'Mr',
              firstName: primaryPax.firstName || '',
              lastName: primaryPax.lastName || '',
              email: primaryPax.email || '',
              dateOfBirth: primaryPax.dateOfBirth || '',
              phoneNumber: primaryPax.phoneNumber || '',
              isPrimary: true,
            },
            passengers: passengerData.map(p => ({
              id: p.id,
              type: p.type,
              title: p.title || 'Mr',
              firstName: p.firstName || '',
              lastName: p.lastName || '',
              email: p.email || '',
              dateOfBirth: p.dateOfBirth || '',
              phoneNumber: p.phoneNumber || '',
              isPrimary: p.isPrimary || false,
            })),
          },
        }, widgetOrigin);
      });

      window.addEventListener('arcube:widget:error', (e) => {
        console.error('❌ arcube:widget:error', JSON.stringify(e.detail));
      });

      window.addEventListener('arcube:cart:updated', async (event) => {
        console.log('🛒 arcube:cart:updated', JSON.stringify(event.detail));
        const detail = event.detail;
        const type = detail.messageType;
        const cart = detail.cart;
        if (cart && cart.correlationId) currentCorrelationId = cart.correlationId;
        if ((type === 'CART_ITEM_ADDED' || type === 'CART_UPDATED') && cart) {
          const items = cart.selectedAncillaries || [];
          const latestItem = items[items.length - 1];
          if (latestItem) {
            try {
              // Call order-create immediately while correlationId is still valid
              const primaryPax = currentPassengers[0] || {};
              const orderResp = await fetch(`${cfg.apiBase}/api/order-create`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  pnr: currentPnr,
                  ancillary: latestItem,
                  correlationId: currentCorrelationId,
                  passenger: primaryPax,
                }),
              });
              let transactionId = null;
              if (orderResp.ok) {
                const orderData = await orderResp.json();
                transactionId = orderData.transactionId;
                console.log('✅ ARCube order-create OK, transactionId:', transactionId);
              } else {
                const errData = await orderResp.json().catch(() => ({}));
                console.warn('⚠️ ARCube order-create failed:', JSON.stringify(errData));
              }
              await addAncillaryToShopifyCart(latestItem, currentPnr, transactionId);
              console.log('✅ Ancillary added to Shopify cart:', latestItem);
            } catch (err) {
              console.error('❌ Failed to add ancillary to Shopify cart:', err.message);
            }
          }
        }
      });

      window.addEventListener('arcube:widget:resize', e => {
        const container = $('arcube-widget');
        if (container && e.detail && e.detail.height) {
          container.style.height = e.detail.height + 'px';
        }
      });

      window.addEventListener('arcube:widget:closed', () => {
        $('aiw-error-msg').textContent = 'No se encontraron servicios adicionales para este PNR.';
        showStep('error');
      });

      $('aiw-pnr-display').textContent = pnr;
      showStep('widget');

      window.Widget.init({
        widgetUrl: cfg.widgetUrl,
        tenantId: cfg.tenantId,
        sessionId: pnr,
        currency: 'USD',
        language: 'en-EN',
        backendUrl: cfg.backendUrl,
        token: token,
        correlationId: tokenData.correlationId,
        themeJsonUrl: `${cfg.widgetUrl}/api/dev-theme`,
        flightDetails: {
          passengers: 1,
          departure: {
            from: { display: 'Athens (ATH)' },
            to: { display: 'New York (JFK)' },
            arrivalDateTime: '2026-06-12T10:35',
            flightNumber: 'LH1283 / LH400',
          },
          returnFlight: {
            from: { display: 'New York (JFK)' },
            to: { display: 'Athens (ATH)' },
            arrivalDateTime: '2026-06-26T20:30',
            flightNumber: 'LH401 / LH1282',
          },
        },
      });

    } catch (err) {
      $('aiw-error-msg').textContent = `Error: ${err.message}`;
      showStep('error');
    }
  }

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      // Always remove and reload the widget script to avoid stale config
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) existing.remove();
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = () => reject(new Error(`No se pudo cargar el script del widget`));
      document.head.appendChild(s);
    });
  }

  function search() {
    const pnr = $('aiw-pnr').value.trim().toUpperCase();
    if (!pnr) {
      $('aiw-pnr-error').textContent = 'Introduce tu número de reserva';
      return;
    }
    $('aiw-pnr-error').textContent = '';
    const adults = parseInt($('aiw-adults').value) || 1;
    const children = parseInt($('aiw-children').value) || 0;
    const infants = parseInt($('aiw-infants').value) || 0;
    const passengers = buildPassengers(adults, children, infants);
    const passengerData = readPassengerData(passengers);
    currentPassengers = passengerData;
    loadWidget(pnr, passengers, passengerData);
  }

  ['aiw-adults', 'aiw-children', 'aiw-infants'].forEach(id => {
    $(id).addEventListener('change', renderPassengerFields);
  });

  $('aiw-search-btn').addEventListener('click', search);
  $('aiw-pnr').addEventListener('keydown', e => { if (e.key === 'Enter') search(); });
  $('aiw-back-btn').addEventListener('click', () => showStep('pnr'));
  $('aiw-retry-btn').addEventListener('click', () => showStep('pnr'));

  renderPassengerFields();
})();
